import React from 'react';
import { Image } from '@fiverr-private/media';
import SafeComponent from '../../shared/SafeComponent';

interface TrustedByItemProps {
    src: string;
    alt: string;
}

const TrustedByItem = ({ src, alt }: TrustedByItemProps) => (
    <Image width="auto" height="auto" maxHeight="100%" src={src} alt={alt} />
);

export default SafeComponent(TrustedByItem);
